import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/components/AuthShell";
import { PasswordInput } from "@/components/PasswordInput";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState({ a: "", b: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.a.length < 6) return setError("La password deve avere almeno 6 caratteri");
    if (pw.a !== pw.b) return setError("Le password non coincidono");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw.a });
      setDone(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Nuova password" subtitle="Scegli una nuova password per il tuo account." testId="reset-page">
      {done ? (
        <div className="space-y-5" data-testid="reset-success">
          <p className="flex items-center gap-2 rounded-2xl bg-[#E8EEF8] p-4 text-sm text-[#0F2D5E]"><CheckCircle2 className="h-5 w-5" /> Password aggiornata.</p>
          <Button asChild className="h-12 w-full rounded-full bg-[#0F2D5E]"><Link to="/accedi" data-testid="reset-go-login">Accedi</Link></Button>
        </div>
      ) : !token ? (
        <p className="text-sm text-red-700" data-testid="reset-no-token">Link non valido. Richiedine uno nuovo da "Password dimenticata".</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <div className="space-y-2">
            <Label>Nuova password</Label>
            <PasswordInput required value={pw.a} onChange={(e) => setPw({ ...pw, a: e.target.value })} testId="reset-password-input" />
          </div>
          <div className="space-y-2">
            <Label>Conferma password</Label>
            <PasswordInput required value={pw.b} onChange={(e) => setPw({ ...pw, b: e.target.value })} testId="reset-password-confirm-input" />
          </div>
          {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="reset-error">{error}</p>}
          <Button type="submit" disabled={loading} className="h-12 w-full rounded-full bg-[#0F2D5E] hover:bg-[#0B2250]" data-testid="reset-submit-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Salva password
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
